"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Pin2: ['pin-2', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M11.250 6.749 A6.000 6.000 0 1 0 23.250 6.749 A6.000 6.000 0 1 0 11.250 6.749 Z', 'M14.25,7.5A3.75,3.75,0,0,1,18,3.749', 'M0.75 23.249L13.008 10.991']],
  Pin: ['pin', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M4.949,8.783a1.5,1.5,0,0,0-.3,2.356l8.213,8.213a1.5,1.5,0,0,0,2.356-.3,7.522,7.522,0,0,0,.81-5.54l6.529-4.155a1.5,1.5,0,0,0,.256-2.326L16.97,1.188a1.5,1.5,0,0,0-2.326.255l-4.155,6.53A7.522,7.522,0,0,0,4.949,8.783Z', 'M8.753 15.246L0.75 23.249']]
};
exports["default"] = _default;